import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form, Card, Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import {
  getUserHotelBookingDetailById,
  cancelHotelBooking,
  checkCancellationFees
} from "../../Action/user.action";
import { CencelBookingSchema } from "../../validations/addProperty";
import config from "../../coreFIles/config";
import config1 from "../../config";
import { Formik } from "formik";
import { toast, Toaster } from "react-hot-toast";
import moment from "moment";
import Cookies from "js-cookie";

const loginData = Cookies.get("loginSuccessPropertyOwner")
  ? JSON.parse(Cookies.get("loginSuccessPropertyOwner"))
  : null;

const ZenCancellation = () => {
  const { bookingId } = useParams();
  const [propertyDetails, setPropertyDetails] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancellationData, setCancellationData] = useState({});
  const [cancellationError, setCancellationError] = useState(null);
  const [isCancelling, setIsCancelling] = useState(false);
  const [formValues, setFormValues] = useState(null);

  useEffect(() => {
    fetchHotelDetails();
  }, []);

  const fetchHotelDetails = async () => {
    try {
      let res = await getUserHotelBookingDetailById({ id: bookingId });
      if (res.success && res.data) {
        const booking = res.data;

        let imageUrl = "/images/no_image_found2.jpg";
        if (
          Array.isArray(booking?.propertyData?.selectedRoom?.images) &&
          booking.propertyData.selectedRoom.images.length > 0
        ) {
          imageUrl = booking.propertyData.selectedRoom.images[0].fileNameImage;
        }

        let parsedPaymentResponse = {};
        try {
          parsedPaymentResponse = booking?.paymentResponse
            ? JSON.parse(booking.paymentResponse)
            : {};
        } catch (e) {
          console.warn("Invalid paymentResponse JSON", e);
        }

        setPropertyDetails({
          id: booking.id,
          image: imageUrl,
          propertyName: booking?.propertyData?.hotelName || "Unknown Hotel",
          numberOfAdults: booking?.propertyData?.totalAdults || 0,
          numberOfChildren: booking?.propertyData?.totalChildren || 0,
          roomTypeName:
            booking?.propertyData?.selectedRoom?.roomName || "Standard Room",
          amount: booking?.amount || "0.00",
          taxAmount: booking?.propertyData?.selectedRoom?.basePrice || 0,
          location: booking?.propertyData?.address || "Unknown Location",
          checkInDate: booking?.checkin
            ? moment(booking.checkin).format("YYYY-MM-DD")
            : "N/A",
          checkOutDate: booking?.checkout
            ? moment(booking.checkout).format("YYYY-MM-DD")
            : "N/A",
          dateTime: booking?.dateTime
            ? moment(booking.dateTime).format("YYYY-MM-DD")
            : "N/A",
          guestDetail: booking?.guestData || {},
          propertyId: booking?.hotelId || "",
          roomId: booking?.roomId || "",
          bookingRefId: booking?.bookingRefId || "",
          providerConfirmationNumber:
            parsedPaymentResponse?.providerConfirmationNumber || "",
          correlationId: booking?.correlationId || "",
          totalGuestsCount:
            (booking?.propertyData?.totalAdults || 0) +
            (booking?.propertyData?.totalChildren || 0),
          cashbackApplied: booking?.cashbackApplied || "0.00",
          finalAmount: booking?.finalAmount || "0.00",
          discountAmount: booking?.discountAmount || "0.00",
          discountPercent: booking?.discountPercent || "0",
          cancellationReason: booking?.cancellationReason || "",
          bankName: booking?.bankName || "",
          bankAddress: booking?.bankAddress || "",
          accountNumber: booking?.accountNumber || "",
          swiftCode: booking?.swiftCode || "",
          IBANNumber: booking?.IBANNumber || "",
          paymentReceipt: booking?.paymentReceipt || null,
          isReimbursed: booking?.isReimbursed || 0,
        });
      } else {
        setPropertyDetails(null);
      }
    } catch (error) {
      console.error("Error fetching hotel details", error);
      setPropertyDetails(null);
    }
  };

  // Step 1: Handle Form Submit -> Check cancellation fees first
  const handleCheckFees = async (values) => {
    setIsProcessing(true);
    setFormValues(values);
    try {
      const res = await checkCancellationFees({
        data: {
          bookingRefId: propertyDetails.bookingRefId,
          correlationId: propertyDetails?.correlationId
        }
      });


      if (res.data) {
        setCancellationData({
          currency: res.data.currency || 'USD',
          totalFee: res.data.totalFee || 0,
          agencyFee: res.data.agencyFee || 0,
          providerFee: res.data.providerFee || 0,
          cancellationPolicies: res.data.cancellationPolicies || []
        });
        setCancellationError(null);
      } else {
        setCancellationError("No cancellation data received");
      }
      setShowCancelModal(true);
    } catch (error) {
      console.error("Error checking cancellation fees", error);
      setCancellationError("Failed to load cancellation fees");
      setShowCancelModal(true);
    } finally {
      setIsProcessing(false);
    }
  };

  // Step 2: Confirm cancellation -> Call API
  const confirmCancellation = async () => {
    setIsCancelling(true);
    const payload = {
      bookingRefId: propertyDetails?.bookingRefId,
      correlationId: propertyDetails?.correlationId,
      userId: loginData?.id,
      cancellationReason: formValues?.cancellationReason,
      bankName: formValues?.bankName,
      bankAddress: formValues?.bankAddress,
      bankAccountName: formValues?.bankAccountName,
      accountNumber: formValues?.accountNumber,
      swiftCode: formValues?.swiftCode,
      ibanNumber: formValues?.ibanNumber,
    };

    let res = await cancelHotelBooking(payload);
    if (res.success) {
      toast.success(res.message || "Booking cancelled successfully");
      setTimeout(() => {
        window.location.href = `${config.baseUrl}${config1.loginurluser}/hotelbooking`;
      }, 2000);
    } else {
      toast.error(res.message || "Failed to cancel booking");
    }
    setIsCancelling(false);
  };

  const formatCancellationRules = () => {
    if (!cancellationData.cancellationPolicies || cancellationData.cancellationPolicies.length === 0) {
      return (
        <tr>
          <td colSpan="2" className="text-center">No cancellation rules available</td>
        </tr>
      );
    }

    return cancellationData.cancellationPolicies.flatMap((policy, policyIndex) => {
      if (!policy.rules || policy.rules.length === 0) {
        return (
          <tr key={`policy-${policyIndex}`}>
            <td colSpan="2">{policy.text || "No details provided"}</td>
          </tr>
        );
      }

      return policy.rules.map((rule, ruleIndex) => (
        <tr key={`policy-${policyIndex}-rule-${ruleIndex}`}>
          <td>
            {moment(rule.start).format("YYYY-MM-DD HH:mm")} -{" "}
            {moment(rule.end).format("YYYY-MM-DD HH:mm")}
          </td>
          <td>
            ${(rule.estimatedValue).toFixed(2)}
          </td>
        </tr>
      ));
    });
  };


  if (!propertyDetails) {
    return (
      <div className="text-center mt-5">
        <h5>Loading booking details...</h5>
      </div>
    );
  }

  return (
    <div>
      <section className="yourbooking pt-5 pb-5 overflow-hidden vh-80">
        <Container>
          <Toaster />
          <Row className="column-reverse-mobile">
            <Col lg={6} className="mb-4">
              <div className="mt-4">
                <Formik
                  enableReinitialize
                  initialValues={{
                    cancellationReason: propertyDetails.cancellationReason || "",
                    bankName: propertyDetails.bankName || "",
                    bankAddress: propertyDetails.bankAddress || "",
                    bankAccountName: "",
                    accountNumber: propertyDetails.accountNumber || "",
                    swiftCode: propertyDetails.swiftCode || "",
                    ibanNumber: propertyDetails.IBANNumber || "",
                  }}
                  validationSchema={CencelBookingSchema}
                  onSubmit={(values) => handleCheckFees(values)}
                >
                  {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    touched,
                    values,
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <Form.Group className="mb-3">
                        <h4>
                          <b>Please let us know why you need to cancel</b>
                        </h4>
                        <Form.Control
                          name="cancellationReason"
                          as="textarea"
                          rows={5}
                          value={values.cancellationReason}
                          placeholder="Write reason here"
                          onChange={handleChange}
                        />
                        {errors.cancellationReason &&
                          touched.cancellationReason && (
                            <div className="text-danger">
                              {errors.cancellationReason}
                            </div>
                          )}
                      </Form.Group>

                      <h6>
                        <b>Refund Payment Details</b>
                      </h6>

                      <input
                        type="text"
                        name="bankName"
                        value={values.bankName}
                        onChange={handleChange}
                        placeholder="Bank Name"
                        className="form-control border-1 mt-2"
                      />
                      {errors.bankName && touched.bankName && (
                        <div className="text-danger">{errors.bankName}</div>
                      )}

                      <input
                        type="text"
                        name="bankAddress"
                        value={values.bankAddress}
                        onChange={handleChange}
                        placeholder="Bank Address"
                        className="form-control border-1 mt-2"
                      />
                      {errors.bankAddress && touched.bankAddress && (
                        <div className="text-danger">{errors.bankAddress}</div>
                      )}

                      <input
                        type="text"
                        name="bankAccountName"
                        value={values.bankAccountName}
                        onChange={handleChange}
                        placeholder="Bank Account Holder Name"
                        className="form-control border-1 mt-2"
                      />

                      <input
                        type="text"
                        name="accountNumber"
                        value={values.accountNumber}
                        onChange={handleChange}
                        placeholder="Bank Account Number"
                        className="form-control border-1 mt-2"
                      />

                      <input
                        type="text"
                        name="swiftCode"
                        value={values.swiftCode}
                        onChange={handleChange}
                        placeholder="Swift Code"
                        className="form-control border-1 mt-2"
                      />

                      <input
                        type="text"
                        name="ibanNumber"
                        value={values.ibanNumber}
                        onChange={handleChange}
                        placeholder="IBAN Number"
                        className="form-control border-1 mt-2"
                      />

                      <div className="mt-3">
                        <Button
                          variant="primary"
                          disabled={isProcessing}
                          type="submit"
                          className="rounded-2"
                        >
                          {isProcessing ? "Processing..." : "Check Cancellation Fees"}
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </Col>

            <Col lg={1}></Col>

            <Col lg={5} className="mb-4">
              <Card>
                <img
                  width="100%"
                  src={propertyDetails?.image || "assets/images/no-image.avif"}
                  alt="Hotel"
                />
                <div className="px-2">
                  <div className="mt-4">
                    <h5 className="mb-2">
                      <b>{propertyDetails?.propertyName}</b>
                    </h5>
                    <div className="d-flex justify-content-between">
                      <h6>{propertyDetails?.location}</h6>
                    </div>
                  </div>
                  <hr />
                  <Row>
                    <Col lg={4}>
                      <b>Check-in</b>
                      <p className="text-grey mb-0">
                        {propertyDetails?.checkInDate}
                      </p>
                    </Col>
                    <Col lg={4}>
                      <b>Check-out</b>
                      <p className="text-grey mb-0">
                        {propertyDetails?.checkOutDate}
                      </p>
                    </Col>
                    <Col lg={4}>
                      <b>Guests</b>
                      <p className="text-grey mb-0">
                        {propertyDetails?.totalGuestsCount} Guest(s)
                      </p>
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mt-4 mb-4">
                    <Col lg={6}>
                      <h6>Total Amount :</h6>
                    </Col>
                    <Col lg={6} className="text-right">
                      <span className="text-grey">
                        ${propertyDetails?.amount}
                      </span>
                    </Col>
                    <Col lg={6}>
                      <h6>Discount ({propertyDetails.discountPercent}%) :</h6>
                    </Col>
                    <Col lg={6} className="text-right">
                      <span className="text-grey">
                        ${propertyDetails?.discountAmount}
                      </span>
                    </Col>
                    <Col lg={6}>
                      <h5>
                        <b>Amount Paid:</b>
                      </h5>
                    </Col>
                    <Col lg={6} className="text-right">
                      <h5 className="text-grey">
                        ${parseFloat(propertyDetails?.finalAmount)}
                      </h5>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Cancellation Modal */}
        <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Cancellation Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {cancellationError ? (
              <div className="alert alert-danger">{cancellationError}</div>
            ) : (
              <div>
                <h5>Cancellation Policy</h5>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Period</th>
                      <th>Fee</th>
                    </tr>
                  </thead>
                  <tbody>{formatCancellationRules()}</tbody>
                </table>

                <div className="mt-3">
                  <h6>
                    Total Cancellation Fee: ${cancellationData.totalFee ? cancellationData.totalFee.toFixed(2) : "0.00"}

                  </h6>
                  {cancellationData.agencyFee > 0 && (
                    <p>
                      Agency Fee: {cancellationData.agencyFee}{" "}
                      {cancellationData.currency}
                    </p>
                  )}
                  {cancellationData.providerFee > 0 && (
                    <p>
                      Provider Fee: {cancellationData.providerFee}{" "}
                      {cancellationData.currency}
                    </p>
                  )}
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowCancelModal(false)}
            >
              Close
            </Button>
            {!cancellationError && (
              <Button
                variant="danger"
                onClick={confirmCancellation}
                disabled={isCancelling}
              >
                {isCancelling ? "Cancelling..." : "Confirm Cancellation"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </section>
    </div>
  );
};

export default ZenCancellation;
